import {createSvgIcon} from "@mui/material";

const OtherFileIcon = ({extension}: { extension: string | undefined}) => {
  const truncateText = (text: string | undefined, maxLength: number) => {
    if (!text) return "file"; // Значение по умолчанию
    return text.length > maxLength ? `${text.slice(0, maxLength)}` : text;
  };

  const shortenedExtension = truncateText(extension, 6);

  const Icon = createSvgIcon(
    <svg width="47" height="56" viewBox="0 0 47 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.2353 0H2.76471C1.2378 0 0 1.2536 0 2.8V53.2C0 54.7464 1.2378 56 2.76471 56H44.2353C45.7622 56 47 54.7464 47 53.2V2.8C47 1.2536 45.7622 0 44.2353 0Z"
        fill="#6F6F6F"/>
      <text
        x="50%"
        y="12px"
        fill="#FFF"
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="'Pragmatica Extended', sans-serif"
        fontSize="11"
        fontWeight="500"
        fontStyle="normal"
      >
        {shortenedExtension}
      </text>
      <rect x="11" y="23" width="25" height="25" rx="2" fill="#C5C5C5"/>
      <path d="M30 31.3334L21.3333 40" stroke="#6E6E6E" strokeWidth="2.70833" strokeLinecap="round"/>
      <path d="M17 35.6666L21.3333 40" stroke="#6E6E6E" strokeWidth="2.70833" strokeLinecap="round"/>
    </svg>,
    'OtherFile'
  )

  return <Icon/>
}

export default OtherFileIcon;
